import Image from 'next/image';
import photo from '../../public/yura-kriachko.png';

const YuraTeamMember = () => {
  return (
    <div className="flex flex-col md:flex-row items-center justify-center md:justify-between mt-16 mb-16 mx-4 md:mx-24">
      <div className="mb-10 md:mb-0">
        <Image
          src={photo}
          alt="Yura Kriachko"
          className="w-48 h-48 rounded-full"
        />
      </div>
      <div className="md:w-2/3 md:pl-10">
        <h2 className="text-3xl font-bold mb-5">Creator of upscore.ai</h2>
        <p className="mb-5">
          Hi there! My name is Yura Kriachko, and I am the creator of
          upscore.ai. I grew up in a small village in Ukraine, where English was
          not taught well, but I was always fascinated by the language and knew
          its importance. After graduating high school, I decided to pursue my
          dreams of studying abroad and taking the IELTS exam to qualify. Not
          only did I pass, but I also significantly improved my English skills
          in the process.
        </p>
        <p className="mb-5">
          Along the way, I started my first software development company and got
          my first customer on Upwork. Over the years, I've gained 15 years of
          experience as a software developer and entrepreneur, specializing in
          data science and natural language processing. I never stopped learning
          and even took the IELTS exam twice myself, so I know firsthand how
          challenging it can be to improve one's writing score.
        </p>
        <p className="mb-5">
          That's why I created upscore.ai, a tool that uses specialized AI
          algorithms to quickly check essays and provide custom-tailored
          suggestions for improvement. Our goal is to make it convenient and
          easy for you to practice your essay writing skills and achieve your
          goals on the IELTS exam. We provide estimated scores based on the
          official IELTS criteria of task response, coherence and cohesion,
          vocabulary, and grammar, as well as highlight strong points and exact
          mistakes made by the student in the essay.
        </p>
        <p>
          Check out my{' '}
          <a
            href="https://www.linkedin.com/in/yura-kriachko/"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            LinkedIn
          </a>{' '}
          to learn more about my professional background. Thank you for visiting
          upscore.ai, and I hope our website helps you achieve your goals and
          succeed on the IELTS exam. Start improving your writing score today at{' '}
          <a
            href="/trainer"
            target="_blank"
            rel="noopener noreferrer"
            className="underline"
          >
            upscore.ai/trainer
          </a>
          !
        </p>
      </div>
    </div>
  );
};

export default YuraTeamMember;
